import { OfferMetaSchema } from '@funtech-int/yango-shared';
import { CustomTexts } from '@plus-int/acq-toolkit';

import { useLogger } from './useLogger';

export const usePaywallMetaStrictViewModel = <T>(
    customTexts: CustomTexts | undefined,
    schema: OfferMetaSchema<T>
): T => {
    const result = schema.validate(customTexts);
    const logger = useLogger();

    if (!result.success) {
        logger.error({ issues: result.issues }, 'Failed to parse offer meta scheme');
        throw new Error('Failed to parse offer meta scheme');
    }

    return result.data;
};
